import { createContext } from "react";

const AllStateContext = createContext({});

export default AllStateContext;
